import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Menu,
  X,
  ChevronDown,
  Sparkles,
  Phone,
  Mail,
} from "lucide-react";

const Head = () => {

  const location = useLocation();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [aiMenuOpen, setAiMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const aiFeatures = [
    {
      name: "Law and Legal",
      path: "/ai-features/law-and-legal",
    },
    {
      name: "Manufacturing",
      path: "/ai-features/manufacturing",
    },
    {
      name: "Healthcare",
      path: "/ai-features/healthcare",
    },
    // {
    //   name: "CA Firm",
    //   path: "/ai-features/ca-firm",
    // },
    // {
    //   name: "Real Estate",
    //   path: "/ai-features/real-estate",
    // },
    // {
    //   name: "EdTech",
    //   path: "/ai-features/edtech",
    // },
    // {
    //   name: "Enterprise",
    //   path: "/ai-features/enterprise",
    // },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full mb-0">

      {/* TOP BAR */}
      <div className="bg-black text-white">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">

          <div className="flex flex-col sm:flex-row items-center justify-between gap-2">

            {/* LEFT */}
            <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3 text-xs sm:text-sm">

              <a
                href="tel:+917030055128"
                className="flex items-center gap-2 hover:text-blue-400 transition"
              >
                <Phone size={14} />
                +91-7030055128
              </a>

              <span className="hidden sm:block text-gray-500">|</span>

              <a
                href="mailto:enquiry@thinkquotient.ai"
                className="flex items-center gap-2 hover:text-blue-400 transition"
              >
                <Mail size={14} />
                enquiry@thinkquotient.ai
              </a>

            </div>

            {/* RIGHT */}
            <div className="hidden md:flex items-center gap-2 text-xs text-blue-300">

              <Sparkles size={14} />

              AI Automation Solutions For Businesses

            </div>

          </div>

        </div>

      </div>

      {/* MAIN NAVBAR */}
      <div className="bg-white/90 backdrop-blur-xl border-b border-gray-200 shadow-sm">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="flex items-center justify-between h-20">

            {/* LOGO */}
            <Link to="/" className="flex items-center gap-3">

              <div className="bg-white rounded-xl p-2 shadow-sm border border-gray-100">

                <img
                  src="/assets/images/envelop.png"
                  alt="ThinkQuotient"
                  className="h-8 sm:h-10 object-contain"
                />

              </div>

            </Link>

            {/* DESKTOP NAV */}
            <nav className="hidden lg:flex items-center gap-3">

              {/* HOME */}
              <Link
                to="/"
                className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300
                ${isActive("/")
                    ? "bg-blue-600 text-white shadow-lg"
                    : "text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                  }`}
              >
                Home
              </Link>

              {/* AI FEATURES */}
              <div
                className="relative group"
              >

                <button
                  className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300
                  ${location.pathname.includes("/ai-features")
                      ? "bg-blue-600 text-white shadow-lg"
                      : "text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                    }`}
                >

                  AI Features

                  <ChevronDown size={16} />

                </button>

                {/* DROPDOWN */}
                <div className="absolute left-0 top-full pt-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">

                  <div className="w-72 bg-white rounded-2xl border border-gray-100 shadow-2xl overflow-hidden">

                    <div className="px-5 py-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">

                      <h3 className="font-bold text-gray-900">
                        Select Industry
                      </h3>

                      <p className="text-sm text-gray-500 mt-1">
                        Explore AI solutions for businesses
                      </p>

                    </div>

                    <div className="p-2">

                      {aiFeatures.map((item, index) => (

                        <Link
                          key={index}
                          to={item.path}
                          className="flex items-center justify-between px-4 py-3 rounded-xl text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-all duration-200"
                        >

                          {item.name}

                          {/* <ChevronDown
                            size={14}
                            className="-rotate-90"
                          /> */}

                        </Link>

                      ))}

                    </div>

                  </div>

                </div>

              </div>

            </nav>

            {/* CTA + MOBILE */}
            <div className="flex items-center gap-3">

              {/* CTA BUTTON */}
              <Link
                to="/registerWebinar"
                className="hidden sm:inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-5 py-3 rounded-xl text-sm font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              >

                <Sparkles size={16} />

                Free Webinar

              </Link>

              {/* MOBILE BUTTON */}
              <button
                onClick={toggleMobileMenu}
                className="lg:hidden w-11 h-11 rounded-xl border border-gray-200 flex items-center justify-center text-gray-700 hover:bg-gray-100 transition"
              >

                {mobileMenuOpen ? <X size={22} /> : <Menu size={22} />}

              </button>

            </div>

          </div>

        </div>

      </div>

      {/* MOBILE MENU */}
      <div
        className={`lg:hidden fixed inset-0 z-50 transition-all duration-300
        ${mobileMenuOpen
            ? "opacity-100 visible"
            : "opacity-0 invisible"
          }`}
      >

        {/* OVERLAY */}
        <div
          className="absolute inset-0 bg-black/50 backdrop-blur-sm"
          onClick={toggleMobileMenu}
        ></div>

        {/* SIDEBAR */}
        <div
          className={`absolute right-0 top-0 h-full w-[85%] sm:w-[400px] bg-white shadow-2xl transition-transform duration-300
          ${mobileMenuOpen
              ? "translate-x-0"
              : "translate-x-full"
            }`}
        >

          {/* HEADER */}
          <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">

            <h2 className="text-xl font-bold text-gray-900">
              Menu
            </h2>

            <button
              onClick={toggleMobileMenu}
              className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center"
            >

              <X size={20} />

            </button>

          </div>

          {/* NAV */}
          <div className="p-5 overflow-y-auto h-[calc(100vh-80px)]">

            {/* HOME */}
            <Link
              to="/"
              onClick={toggleMobileMenu}
              className={`block px-5 py-4 rounded-2xl text-base font-semibold transition mb-3
              ${isActive("/")
                  ? "bg-blue-600 text-white"
                  : "bg-gray-50 text-gray-700"
                }`}
            >
              Home
            </Link>

            {/* AI FEATURES */}
            <div className="mb-3">

              <button
                onClick={() => setAiMenuOpen(!aiMenuOpen)}
                className="w-full flex items-center justify-between px-5 py-4 rounded-2xl bg-gray-50 text-gray-700 font-semibold"
              >

                AI Features

                <ChevronDown
                  size={18}
                  className={`transition-transform duration-300
                  ${aiMenuOpen ? "rotate-180" : ""}
                  `}
                />

              </button>

              {/* SUBMENU */}
              <div
                className={`overflow-hidden transition-all duration-300
                ${aiMenuOpen
                    ? "max-h-[500px] mt-3"
                    : "max-h-0"
                  }`}
              >

                <div className="space-y-2 pl-3">

                  {aiFeatures.map((item, index) => (

                    <Link
                      key={index}
                      to={item.path}
                      onClick={toggleMobileMenu}
                      className="block px-4 py-3 rounded-xl text-sm font-medium bg-blue-50 text-blue-700 hover:bg-blue-100 transition"
                    >

                      {item.name}

                    </Link>

                  ))}

                </div>

              </div>

            </div>

            {/* CTA */}
            <Link
              to="/registerWebinar"
              onClick={toggleMobileMenu}
              className="mt-6 flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-5 py-4 rounded-2xl text-base font-semibold shadow-lg"
            >

              <Sparkles size={18} />

              Register Free Webinar

            </Link>

          </div>

        </div>

      </div>

    </header>
  );
};

export default Head;